export default __webpack_public_path__ + "static/media/app-google-play.297ea45b.svg";